import { motion } from 'framer-motion';
import Lottie from 'lottie-react';
import { useState, useEffect } from 'react';

interface LottieAnimation {
  v: string;
  fr: number;
  ip: number;
  op: number;
  w: number;
  h: number;
  nm: string;
  ddd: number;
  assets: any[];
  layers: any[];
  markers: any[];
}

const Contact = () => {
  const [animationData, setAnimationData] = useState<LottieAnimation | null>(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    fetch('/assets/Email motion loading.json')
      .then(response => response.json())
      .then(data => {
        setAnimationData(data);
        setIsLoading(false);
      })
      .catch(error => {
        console.error('Error loading animation:', error);
        setIsLoading(false);
      });
  }, []);

  const openForm = () => {
    window.open('https://forms.visme.co/formsPlayer/j0n97m11-portolio-email', '_blank', 'noopener,noreferrer');
  };

  return (
    <div className="w-full bg-gray-900 overflow-hidden">
      <div className="container mx-auto px-4 py-8">
        <motion.h2 
          className="text-4xl md:text-5xl font-bold mb-2 text-center bg-gradient-to-r from-green-400 to-emerald-500 bg-clip-text text-transparent"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          Contactez-moi
        </motion.h2>
        <p className="text-center text-gray-300 max-w-2xl mx-auto mb-6 text-sm md:text-base">
          Vous avez une question ou souhaitez discuter d'un projet ? N'hésitez pas à me contacter via le formulaire.
        </p>
        <div className="flex justify-center mt-8">
          {isLoading ? (
            <div className="w-[300px] h-[300px] flex items-center justify-center">
              <div className="w-12 h-12 border-4 border-green-500 border-t-transparent rounded-full animate-spin"></div>
            </div>
          ) : animationData ? (
            <Lottie
              animationData={animationData}
              loop={true}
              autoplay={true}
              style={{ height: '300px', width: '300px' }}
            />
          ) : (
            <div className="w-[300px] h-[300px] flex items-center justify-center text-red-500">
              Erreur de chargement de l'animation
            </div>
          )}
        </div>
        <div className="flex justify-center mt-6">
          <motion.button
            onClick={openForm}
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            className="px-8 py-3 bg-gradient-to-r from-green-500 to-emerald-600 text-white font-medium rounded-full shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1 cursor-pointer"
          >
            Accéder au formulaire
          </motion.button>
        </div>
      </div>
    </div>
  );
};

export default Contact;